<!--GroupButtons:多组按钮组件 2022/01/10 10:26:29 YuAng-->

<template>
  <ul class="its-group-buttons" :class="theme">
    <li v-for="(group,index) in groups" :key="'group' + index">
      <p :style="{'margin-top':index === 0 ? 0 : '16px', 'font-weight': 'bold'}">{{group.stageName}}</p>
      <ul>
        <li v-for="(item,index) in group.courses" :class="{active: item.courseId === currentItem.courseId}" :key="'child' + index" @click="itemAction(item)">{{item.courseName}}</li>
      </ul>
    </li>
  </ul>
</template>
<script>
import { teacherHomeApi } from '@/utils/api'
export default {
  name: 'GroupButtons',
  data() {
    return {
      groups: [],
      theme: 'light',
      currentItem: { active: false }
    }
  },
  async created() {
    const teachInfo = await this.$store.getters.teachInfo
    if (teachInfo) {
      this.groups = teachInfo
    }
  },
  methods: {
    itemAction: function (item, auto = false) {
      if (window.xkwTracker) {
        window.xkwTracker.$subject = item.subjectId
        window.xkwTracker.$stage = item.stage
      }
      this.currentItem = item
      teacherHomeApi.postCurrentCourse(item.courseId).then(() => {
        this.$emit('click-btn', { item, auto })
      })
    }
  }
}
</script>

<style scoped>
.its-group-buttons {
  padding-bottom: 20px;
}

.its-group-buttons ul li {
  display: inline-block;
  background: #ffffff;
  border: 1px solid #2695ff;
  color: #2695ff;
  margin: 7px 14px 3px 0;
  font-size: 12px;
  padding: 4px 21px 3px 21px;
  border-radius: 3px;
  cursor: pointer;
}

.its-group-buttons ul li.active {
  background: #2695ff;
  color: white;
}

.its-group-buttons.dark li p {
  color: white;
}

.its-group-buttons.dark ul li {
  background: #f2f8ff;
  border-color: transparent;
  color: white;
}
</style>
